import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {label} from './Dictionary.js';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import WifiIcon from '@mui/icons-material/Wifi';
import Avatar from '@mui/material/Avatar';
import TagIcon from '@mui/icons-material/Tag';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import * as Server from "./Server.js"
import InfoIcon from '@mui/icons-material/InfoOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import RestoreOutlinedIcon from '@mui/icons-material/RestoreOutlined';

function Stats({isVisible, onDialogClick=()=>{}}) {
  const searchParams = new URLSearchParams(document.location.search);
  const [stats, setStats] = React.useState({});

  function GatherInfo() {

        Server.GetDeviceDetails(searchParams.get("device_id"))
        .then((res) => {
            let stats = {}
            stats.next_event_time = Server.TimeFormat24To12(res.data.next_scheduled_check_time_24_hrs)
            if (res.data.playlist.items.length>0)
                stats.next_event_name = "Display playlist item (" + (res.data.playlist_name=="playlist" ? "Primary" : "Secondary") + ")"
            else
                stats.next_event_name = "Check for Changes"
            if (res.data.status == "Active") {
                let mins = Math.floor(res.data.wake_status.seconds_to_sleep / 60)
                let secs = res.data.wake_status.seconds_to_sleep % 60
                stats.status = "Live Controls (" + mins + ":" + String(secs).padStart(2,'0') + ")"
            } else
                stats.status = res.data.status
            stats.wifi_status = res.data.status == "Unknown" ? "Disconnected" : "Connected"
            let local_date_time_str = new Date(res.data.last_checkin_timestamp).toLocaleString('en-US', { timeZone: res.data.config.timezone, hour12: true });
            stats.last_checkin_timestamp = local_date_time_str
            let update_interval_mins = Server.GetUpdateIntervalMinutes(res.data.config.update_times_24_hrs)
            if (update_interval_mins==1)
                stats.update_interval = "min"
            else if (update_interval_mins<60)
                stats.update_interval = update_interval_mins + " mins"
            else if(update_interval_mins==60)
                stats.update_interval = "hour"
            else
                stats.update_interval = update_interval_mins / 60 + " hours"
            setStats(stats)
        })
    }

    React.useEffect(() => {

        GatherInfo();
        const interval = setInterval(() => {
            GatherInfo();
        }, 3000);

        return () => clearInterval(interval);

    }, []);

    return (
        <>
          <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
            open={isVisible}
            onClick={onDialogClick}
            >
            <Card sx={{ maxWidth: 445 }}>
            <CardContent>
            <Typography gutterBottom variant="h5" component="div">
            {label("ID_Status")}
            </Typography>
            <List dense sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                <ListItem>
                    <ListItemAvatar>
                    <Avatar>
                        <TagIcon />
                    </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={<React.Fragment><b>ID</b></React.Fragment>} secondary={searchParams.get("device_id")} />
                </ListItem>
                <ListItem>
                    <ListItemAvatar>
                    <Avatar>
                        <SystemUpdateAltIcon />
                    </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={<React.Fragment><b>Firmware Version</b></React.Fragment>} secondary="1.2 (latest)" />
                </ListItem>
                <ListItem>
                    <ListItemAvatar>
                    <Avatar>
                        <WifiIcon />
                    </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={<React.Fragment><b>WiFi</b></React.Fragment>} secondary={stats.wifi_status} />
                </ListItem>
                <ListItem>
                    <ListItemAvatar>
                    <Avatar>
                        <InfoIcon />
                    </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={<React.Fragment><b>Status</b></React.Fragment>} secondary={stats.status} />
                </ListItem>
                <ListItem>
                    <ListItemAvatar>
                    <Avatar>
                        <AccessTimeIcon />
                    </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={<React.Fragment><b>Next Wakeup Time</b></React.Fragment>} secondary={stats.next_event_time + " (every " + stats.update_interval + ")"}  />
                </ListItem>
                <ListItem>
                    <ListItemAvatar>
                    <Avatar>
                        <EventOutlinedIcon />
                    </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={<React.Fragment><b>Next Wakeup Event</b></React.Fragment>} secondary={stats.next_event_name} />
                </ListItem>
                <ListItem>
                    <ListItemAvatar>
                    <Avatar>
                        <RestoreOutlinedIcon />
                    </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={<React.Fragment><b>Last Wakeup Time</b></React.Fragment>} secondary={stats.last_checkin_timestamp} />
                </ListItem>
                </List>

            
            </CardContent>
            </Card>

        </Backdrop>
        </>
    );

}

export default Stats;